import { Children, cloneElement, forwardRef, useState } from "react";
import Flx from "../../../../components/layout/Flx";
import { grey } from "@mui/material/colors";
import SearchInputLight from "../../../../components/inputs/SearchInputLight";
import Screen from "../../../../components/layout/Screen";
import isNil from "lodash/isNil";
import AgButtonDownloadTable from "../../../../components/agGrid/AgButtonDownloadTable";
import LoadingFallback from "../../../../components/LoadingFallback";

export const RouteTableScreen = forwardRef(
  ({ rowData, children, downloadName }, ref) => {
    const [quickFilter, setQuickFilter] = useState(null);
    return (
      <>
        <Flx
          fw
          jb
          ac
          sx={{
            px: 1.5,
            py: 0.5,
            background: grey[50],
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <SearchInputLight value={quickFilter} onChange={setQuickFilter} />
          {downloadName && (
            <AgButtonDownloadTable ref={ref} downloadName={downloadName} />
          )}
        </Flx>
        <Screen>
          {isNil(rowData) ? (
            <LoadingFallback />
          ) : (
            Children.map(children, (child) =>
              cloneElement(child, { rowData, quickFilter })
            )
          )}
        </Screen>
      </>
    );
  }
);
